import { render } from "./HeaderComponent.vue?vue&type=template&id=580ebcd0&scoped=true"
import script from "./HeaderComponent.vue?vue&type=script&lang=js"
export * from "./HeaderComponent.vue?vue&type=script&lang=js"

import "./HeaderComponent.vue?vue&type=style&index=0&id=580ebcd0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-580ebcd0"

export default script